import { DaySteps } from "./Day";

/**
 * Time steps for a forecast, both mandatory and optional.
 * There are expected to sometimes be overlaps between both categories (i.e. it's not a partition).
 */
export type Steps = {
  mandatory: number[];
  optional: number[];
};

/**
 * Converts a flattened steps back into a Steps object.
 */
export const restructureSteps = (steps: number[]): Steps => ({
  mandatory: [],
  optional: steps
});

/**
 * Groups time steps into days.
 */
export const stepsToDays = (steps: number[]) =>
  steps.reduce(
    (days, step) => {
      const day = step === 0 ? 1 : Math.ceil(step / 24);
      const match = days.find(d => d.day === day);
      if (match == null) {
        days.push({
          day,
          steps: [step]
        });
      } else {
        match.steps.push(step);
      }
      return days;
    },
    [] as DaySteps[]
  );
